var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYamlDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 4.08301H9.33073V5.24967H4.66406V4.08301Z",
    fill: "#5E6366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 6.41699H9.33073V7.58366H4.66406V6.41699Z",
    fill: "#5E6366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 8.75H7.58073V9.91667H4.66406V8.75Z",
    fill: "#5E6366"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58333 3.16667H3.75C3.42784 3.16667 3.16667 3.42784 3.16667 3.75V10.75C3.16667 11.0722 3.42784 11.3333 3.75 11.3333H9.58333C9.90551 11.3333 10.1667 11.0722 10.1667 10.75V3.75C10.1667 3.42784 9.90551 3.16667 9.58333 3.16667ZM3.75 2C2.7835 2 2 2.7835 2 3.75V10.75C2 11.7165 2.7835 12.5 3.75 12.5H9.58333C10.5499 12.5 11.3333 11.7165 11.3333 10.75V3.75C11.3333 2.7835 10.5499 2 9.58333 2H3.75Z",
    fill: "#5E6366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYamlDropdown);
export default __webpack_public_path__ + "static/media/yamlDropdown.0a62c64b6f967ab03b9b03a739ff9417.svg";
export { ForwardRef as ReactComponent };